<ziro-phone-buttons-edit-form
  #form
  [userMode]="DragDropMode.SELF_SERVE"
  [entity]="buttonToEdit.button"
  [parentSubmit$]="submit$"
  (ziroFormsUpdate$)="onFormUpdate($event)"
></ziro-phone-buttons-edit-form>

<ng-template #errorTemplate>
  @if (isValid === ZiroFormsValidationState.INVALID) {
    <span>
      {{ 'tkey;validators.global.required.missing.error' | translate }}
    </span>
  }
</ng-template>
